import { render, staticRenderFns } from "./AcademicYearSelect.vue?vue&type=template&id=fcb446f6"
import script from "./AcademicYearSelect.vue?vue&type=script&lang=js"
export * from "./AcademicYearSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports